import { HttpClient, HttpParams } from '@angular/common/http';
import { inject } from '@angular/core';
import { ENV_CONFIG, EnvConfig } from '@core';

export class ApiService {
  protected readonly httpClient: HttpClient = inject(HttpClient);
  protected readonly env: EnvConfig = inject(ENV_CONFIG);

  protected fillPathParams(template: string, params: Record<string, string | number>): string {
    return Object.entries(params).reduce(
      (acc: string, [key, value]: [string, string | number]) =>
        acc.replace(new RegExp(`{${key}}`, 'g'), encodeURIComponent(String(value))),
      template
    );
  }

  protected fillQueryParams<T extends Record<string, string | number | boolean | undefined>>(
    queryParams: T
  ): HttpParams {
    return Object.entries(queryParams).reduce(
      (params: HttpParams, [key, value]: [string, string | number | boolean | undefined]) =>
        value !== undefined ? params.set(key, String(value)) : params,
      new HttpParams()
    );
  }
}
